import {
  Button,
  Dialog,
  DialogContent,
  Grid,
  IconButton,
  InputLabel,
  Link,
  ListItem,
  ListItemIcon,
  MenuItem,
  Paper,
  TextField,
  Typography,
  withWidth,
} from "@material-ui/core";
import { AccountCircle, Clear, Delete } from "@material-ui/icons";
import AddIcon from "@material-ui/icons/AddCircle";
import React, { useEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import {
  checkAdmin,
  checkNewSerialNumber,
  contactMethods,
  contactObjectSkeleton,
  ECABIN,
  formatTimeWithTZOffset,
  getDeviceProfiles,
  getToken,
  getUser,
  getWarrantyStatusText,
  requestErrorHandler,
  TICKET_PRIORITIES,
  ticketStates,
  USER_GROUPS,
} from "../../Utils/Common";
import EnvSettings from "../../Utils/EnvSettings";
import { useStyles } from "../../Utils/Styles";
import DetailTabs from "../../Views/DeviceDetails/DetailTabs";
import { showPopupSnackbar } from "../../redux/actions/snackbarActions";
import BrowseContactsDialog from "../Contacts/BrowseContactsDialog";
import ContactInfoBadge from "../Contacts/ContactInfoBadge";
import DeviceSearchAutocomplete from "../DeviceSearchAutocomplete";
import DialogAppBar from "../DialogAppBar";
import StockItemSearch from "../StockItems/StockItemSearch";
import Title from "../Title";
import UserSearchAutocomplete from "../UserSearchAutocomplete";
import ExpenseHeader from "./ExpenseHeader";
import ExpenseItem from "./ExpenseItem";
import MediaFiles from "./MediaFiles";

import { useHistory } from "react-router-dom";

const server = EnvSettings.server;

const InputComponent = ({ inputRef, ...other }) => <div {...other} />;
const OutlinedDiv = ({ children, label }) => {
  return (
    <TextField
      variant="outlined"
      label={label}
      multiline
      fullWidth
      focused={false}
      InputLabelProps={{ shrink: true }}
      InputProps={{
        inputComponent: InputComponent,
      }}
      inputProps={{ children: children }}
    />
  );
};

function ExpenseSegment({
  selectedTicket,
  expenseKey,
  ticketData,
  setTicketData,
}) {
  const [edit, setEdit] = useState();
  const [acKey, setACKey] = useState("dsfasdfds");
  const { t } = useTranslation();
  return (
    <>
      <Grid item container spacing={1} style={{ padding: 5 }}>
        <Grid item xs={12}>
          <InputLabel style={{ marginBottom: 3 }}>
            {t("ticketList." + expenseKey)}
          </InputLabel>
        </Grid>
        <Grid item xs={7}>
          <TextField
            size="small"
            fullWidth
            variant="outlined"
            label={t("name")}
            key={acKey + "3"}
            onChange={(e) => {
              setEdit(
                edit
                  ? { ...edit, name: e.target.value }
                  : { name: e.target.value },
              );
            }}
          ></TextField>
        </Grid>
        <Grid item xs={4}>
          <TextField
            size="small"
            fullWidth
            variant="outlined"
            label={t("price")}
            type={"number"}
            key={acKey + "4"}
            onChange={(e) => {
              setEdit(
                edit
                  ? { ...edit, price: e.target.value }
                  : { price: e.target.value },
              );
            }}
          ></TextField>
        </Grid>
        <Grid item xs={1}>
          <IconButton
            size="small"
            color="primary"
            onClick={() => {
              if (edit) {
                var exp = {
                  ...(selectedTicket ? selectedTicket.expenses : {}),
                };
                if (ticketData && ticketData.expenses) {
                  exp = { ...ticketData.expenses };
                }
                var arr = [];
                if (exp[expenseKey]) {
                  arr = [...exp[expenseKey]];
                  arr.push(edit);
                } else {
                  arr.push(edit);
                }
                exp[expenseKey] = [...arr];
                setTicketData({
                  ...ticketData,
                  expenses: { ...exp },
                });
                setACKey(new Date().toISOString());
              }
            }}
          >
            <AddIcon></AddIcon>
          </IconButton>
        </Grid>
      </Grid>
      <Grid item style={{ padding: 5 }}>
        {(ticketData &&
          ticketData.expenses &&
          ticketData.expenses[expenseKey] &&
          ticketData.expenses[expenseKey].length) ||
        (selectedTicket &&
          selectedTicket.expenses &&
          selectedTicket.expenses[expenseKey] &&
          selectedTicket.expenses[expenseKey].length) ? (
          <ExpenseHeader />
        ) : null}
        {[
          ...(ticketData &&
          ticketData.expenses &&
          ticketData.expenses[expenseKey]
            ? ticketData.expenses[expenseKey]
            : selectedTicket &&
                selectedTicket.expenses &&
                selectedTicket.expenses[expenseKey]
              ? selectedTicket.expenses[expenseKey]
              : []),
        ].map((m, i) => (
          <ExpenseItem
            obj={m}
            key={i}
            onClick={() => {
              var exp = {
                ...(selectedTicket ? selectedTicket.expenses : {}),
              };
              if (ticketData && ticketData.expenses) {
                exp = { ...ticketData.expenses };
              }
              var arr = [];
              arr = [...exp[expenseKey]];
              arr = arr.filter((a) => JSON.stringify(a) !== JSON.stringify(m));
              exp[expenseKey] = [...arr];
              setTicketData({ ...ticketData, expenses: { ...exp } });
            }}
          />
        ))}
      </Grid>
    </>
  );
}

const expenseKeys = ["shippingCosts", "outsourcedServices", "travelCosts"];

function Expenses({ ticketData, setTicketData, selectedTicket }) {
  const { t } = useTranslation();
  const [addNewItem, setAddNewItem] = useState(false);
  const [addPrice, setAddPrice] = useState(false);
  const [newItem, setNewItem] = useState();
  const [acKey, setACKey] = useState("sdfsdfsd");
  return (
    <Grid item xs={12} style={{ borderRadius: 5, borderWidth: 1 }}>
      <OutlinedDiv label={t("ticketList.expenses")}>
        <Grid item container style={{ padding: 5 }} spacing={1}>
          <Grid item xs={12}>
            <InputLabel style={{ marginBottom: 3 }}>
              {t("ticketList.spareParts")}
            </InputLabel>
          </Grid>

          {!addNewItem ? (
            <>
              <Grid item xs={addPrice ? 4 : 7}>
                <StockItemSearch
                  allowNewItems={true}
                  size={"small"}
                  onChange={(e, v) => {
                    if (v && v.sku) {
                      if (v.sku === "Add new item") {
                        setAddNewItem(true);
                        return;
                      }
                      if (!v.costPrice) {
                        setAddPrice(true);
                      }
                      setNewItem(
                        newItem
                          ? {
                              ...newItem,
                              name: v.sku,
                              price: v.costPrice,
                            }
                          : { name: v.sku, price: v.costPrice },
                      );
                    }
                  }}
                  // clearOnSelect={true}
                  includeTags={true}
                  placeholder={t("orders.startSearchingProducts")}
                  key={acKey + "98"}
                />
              </Grid>
              {addPrice ? (
                <Grid item xs={3}>
                  <TextField
                    size="small"
                    variant="outlined"
                    label={t("stockModule.costPrice")}
                    type={"number"}
                    key={acKey + "2"}
                    onChange={(e) => {
                      if (isNaN(e.target.value)) {
                        return;
                      }
                      setNewItem(
                        newItem
                          ? {
                              ...newItem,
                              price: e.target.value,
                            }
                          : { price: e.target.value },
                      );
                    }}
                  ></TextField>
                </Grid>
              ) : null}
            </>
          ) : (
            <>
              <Grid item xs={4}>
                <TextField
                  size="small"
                  variant="outlined"
                  label={t("name")}
                  onChange={(e) => {
                    setNewItem(
                      newItem
                        ? { ...newItem, name: e.target.value }
                        : { name: e.target.value },
                    );
                  }}
                  key={acKey + "1"}
                ></TextField>
              </Grid>
              <Grid item xs={3}>
                <TextField
                  size="small"
                  variant="outlined"
                  label={t("stockModule.costPrice")}
                  type={"number"}
                  key={acKey + "2"}
                  onChange={(e) => {
                    setNewItem(
                      newItem
                        ? { ...newItem, price: e.target.value }
                        : { price: e.target.value },
                    );
                  }}
                ></TextField>
              </Grid>
            </>
          )}
          <Grid item xs={4}>
            <TextField
              variant="outlined"
              type="number"
              size="small"
              fullWidth
              onChange={(e) => {
                setNewItem(
                  newItem
                    ? { ...newItem, count: e.target.value }
                    : { count: e.target.value },
                );
              }}
              inputProps={{ min: 0 }}
              label={t("count")}
              key={acKey + "99"}
            ></TextField>
          </Grid>
          <Grid item xs={1}>
            <IconButton
              size="small"
              color="primary"
              onClick={() => {
                if (newItem) {
                  if (!newItem.name || isNaN(newItem.price) || !newItem.count) {
                    return;
                  }
                  var exp = {
                    ...(selectedTicket ? selectedTicket.expenses : {}),
                  };
                  if (ticketData && ticketData.expenses) {
                    exp = { ...ticketData.expenses };
                  }
                  var arr = [];
                  if (exp.spareParts) {
                    arr = [...exp.spareParts];
                    arr.push(newItem);
                  } else {
                    arr.push(newItem);
                  }
                  exp.spareParts = [...arr];
                  setTicketData({
                    ...ticketData,
                    expenses: { ...exp },
                  });
                  setACKey(new Date().toISOString());
                  setAddNewItem(false);
                  setAddPrice(false);
                  setNewItem();
                }
              }}
            >
              <AddIcon></AddIcon>
            </IconButton>
          </Grid>
        </Grid>

        <Grid item style={{ padding: 5 }}>
          {(ticketData &&
            ticketData.expenses &&
            ticketData.expenses.spareParts &&
            ticketData.expenses.spareParts.length) ||
          (selectedTicket &&
            selectedTicket.expenses &&
            selectedTicket.expenses.spareParts &&
            selectedTicket.expenses.spareParts.length) ? (
            <ExpenseHeader />
          ) : null}
          {[
            ...(ticketData &&
            ticketData.expenses &&
            ticketData.expenses.spareParts
              ? ticketData.expenses.spareParts
              : selectedTicket &&
                  selectedTicket.expenses &&
                  selectedTicket.expenses.spareParts
                ? selectedTicket.expenses.spareParts
                : []),
          ].map((m, i) => (
            <ExpenseItem
              obj={m}
              key={i}
              onClick={() => {
                var exp = {
                  ...(selectedTicket ? selectedTicket.expenses : {}),
                };
                if (ticketData && ticketData.expenses) {
                  exp = { ...ticketData.expenses };
                }
                var arr = [];
                arr = [...exp.spareParts];
                arr = arr.filter(
                  (a) => JSON.stringify(a) !== JSON.stringify(m),
                );
                exp.spareParts = [...arr];
                setTicketData({
                  ...ticketData,
                  expenses: { ...exp },
                });
              }}
            />
          ))}
        </Grid>
        {expenseKeys.map((m) => (
          <ExpenseSegment
            key={m}
            selectedTicket={selectedTicket}
            ticketData={ticketData}
            setTicketData={setTicketData}
            expenseKey={m}
          />
        ))}

        <Grid item xs={12}>
          <Typography>
            {(ticketData && ticketData.expenses) ||
            (selectedTicket && selectedTicket.expenses)
              ? t("ticketList.totalExpenses") + ": "
              : null}

            {ticketData && ticketData.expenses
              ? Object.keys(ticketData.expenses).reduce(
                  (prev, k) =>
                    ticketData.expenses[k].reduce(
                      (prev, curr) =>
                        Number(curr.price) *
                          (curr.count ? Number(curr.count) : 1) +
                        prev,
                      0,
                    ) + prev,
                  0,
                ) + "€"
              : selectedTicket && selectedTicket.expenses
                ? Object.keys(selectedTicket.expenses).reduce(
                    (prev, k) =>
                      selectedTicket.expenses[k].reduce(
                        (prev, curr) =>
                          Number(curr.price) *
                            (curr.count ? Number(curr.count) : 1) +
                          prev,
                        0,
                      ) + prev,
                    0,
                  ) + "€"
                : null}
          </Typography>
        </Grid>
      </OutlinedDiv>
    </Grid>
  );
}

function WhatsAppView({ selectedTicket: _selectedTicket }) {
  const ref = useRef();
  const [message, setMessage] = useState();
  const dispatch = useDispatch();
  const [acKey, setACKey] = useState("sdfasdf");
  const [selectedTicket, setSelectedTicket] = useState(_selectedTicket);

  const sendMessage = () => {
    if (!message) {
      return;
    }
    const requestOptions = {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        token: getToken(),
        ticket_id: selectedTicket.id,
        message: message,
        recipient: selectedTicket.WhatsappMessages[0].WhatsappContact.number,
      }),
    };
    fetch(server + "/send_whatsapp_message", requestOptions)
      .then((res) => res.json())
      .then((result) => {
        requestErrorHandler(result, dispatch);
        if (!result.error) {
          if (result.whatsappmessage) {
            var arr = [...selectedTicket.WhatsappMessages];
            arr.push({
              ...result.whatsappmessage,
              User: { fullName: getUser().name },
            });
            setSelectedTicket({
              ...selectedTicket,
              WhatsappMessages: [...arr],
            });
            setACKey(new Date().toISOString());
          }
        }
      });
  };

  useEffect(() => {
    if (ref && ref.current) {
      // Scroll to the latest message
      ref.current.scrollTo(0, ref.current.scrollHeight);
    }
  }, [ref, acKey]);

  return (
    <>
      <Grid
        item
        xs={12}
        container
        spacing={3}
        style={{
          maxHeight: 370,
          overflowY: "scroll",
          backgroundColor: "#e8ffe8",
          borderRadius: 5,
        }}
        key={acKey}
        ref={ref}
      >
        {selectedTicket && selectedTicket.WhatsappMessages
          ? selectedTicket.WhatsappMessages.sort(
              (a, b) => Number(a.timestamp) - Number(b.timestamp),
            ).map((m, idx) => (
              <Grid
                key={idx}
                item
                xs={12}
                style={{
                  border: "1px solid #000",
                  borderRadius: 10,
                  padding: 15,
                  margin: 5,
                  boxShadow: "rgba(0, 0, 0, 0.2) 2px 2px 0px 0px",
                  backgroundColor: "lightyellow",
                }}
              >
                <Typography style={{ fontSize: 12, whiteSpace: "pre-wrap" }}>
                  {new Date(Number(m.timestamp) * 1000)
                    .toISOString()
                    .substring(0, 19)
                    .replace("T", " ")}
                  {"\n"}
                  {m.User?.fullName ||
                    `${m.WhatsappContact?.name}\n+${m.WhatsappContact?.number}`}
                </Typography>
                <hr />
                {m.type !== "text" ? (
                  <Typography>{`{ ${m.type} }`}</Typography>
                ) : null}
                <Typography>{m.data.body || m.data.caption}</Typography>
              </Grid>
            ))
          : null}
      </Grid>
      <Grid
        item
        xs={12}
        container
        alignItems="center"
        style={{ marginTop: 20 }}
      >
        <Grid item xs={11}>
          <TextField
            variant="outlined"
            label="Message"
            fullWidth
            onChange={(e) => {
              setMessage(e.target.value);
            }}
            key={acKey + "1"}
          ></TextField>
        </Grid>
        <Grid item xs={1}>
          <Button variant="contained" onClick={sendMessage}>
            Send
          </Button>
        </Grid>
      </Grid>
    </>
  );
}

function IdentificationSegment({
  setTicketData,
  Device,
  ticketData,
  selectedTicket,
  showSearch,
}) {
  const { t } = useTranslation();
  const [acKey2, setACKey2] = useState("sdfsdfsd");
  const history = useHistory();
  const dispatch = useDispatch();
  const [clientObject, setClientObject] = useState();
  const [deviceData, setDeviceData] = useState(null);

  const resolvedDeviceId = selectedTicket?.Device?.id || Device?.id;

  const [deviceProfiles, setDeviceProfiles] = useState([]);

  useEffect(() => {
    getDeviceProfiles(setDeviceProfiles, dispatch);
  }, [dispatch]);

  useEffect(() => {
    if (!resolvedDeviceId) {
      setDeviceData(null);
      return;
    }
    const requestOptions = {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        token: getToken(),
        deviceid: resolvedDeviceId,
      }),
    };
    fetch(server + "/get_device_data", requestOptions)
      .then((res) => res.json())
      .then((result) => {
        requestErrorHandler(result, dispatch);
        if (!result.error) {
          setDeviceData(result.device);
        }
      });
  }, [dispatch, resolvedDeviceId]);

  useEffect(() => {
    const getCO = () => {
      var comp =
        (ticketData && ticketData.Company) ||
        (selectedTicket && selectedTicket.Company);
      var cont =
        (ticketData && ticketData.Contact) ||
        (selectedTicket && selectedTicket.Contact);
      if (!cont && !comp) {
        return;
      }

      var v = { ...contactObjectSkeleton };
      if (cont) {
        Object.keys(cont).forEach((m) => {
          if (
            Object.keys(v).find(
              (f) => f.toLowerCase() === ("contact" + m).toLowerCase(),
            )
          ) {
            v["contact" + m[0].toUpperCase() + m.substring(1)] = cont[m];
          }
        });
      }
      if (comp) {
        Object.keys(comp).forEach((m) => {
          if (
            Object.keys(v).find(
              (f) => f.toLowerCase() === ("company" + m).toLowerCase(),
            )
          ) {
            v["company" + m[0].toUpperCase() + m.substring(1)] = comp[m];
          }
        });
      }
      setClientObject(v);
    };
    getCO();
    return () => {
      setClientObject();
    };
  }, [selectedTicket, ticketData]);

  return (
    <Grid item sm={3} xs={12}>
      <Title>{t("ticketList.receivedFrom")}</Title>
      {!Device &&
      (!selectedTicket || (selectedTicket && !selectedTicket.Device)) ? (
        <>
          <Typography
            style={{ paddingTop: 10, paddingBottom: 10, fontWeight: "bold" }}
          >
            {t("ticketList.selectDevice")}
          </Typography>
          <DeviceSearchAutocomplete
            onChange={(e, v) => {
              if (v && typeof v !== "string") {
                if (v.inputValue) {
                  var x = checkNewSerialNumber(
                    v.serialNumber,
                    deviceProfiles,
                    t,
                  );
                  if (x) {
                    alert(x);
                    setTicketData({
                      ...ticketData,
                      DeviceId: undefined,
                    });
                    setACKey2(Date.now());
                    return;
                  }
                  setTicketData({
                    ...ticketData,
                    newDevice: v.serialNumber,
                  });
                  return;
                }

                setTicketData({
                  ...ticketData,
                  DeviceId: v.id,
                });
                return;
              }
              setTicketData({ ...ticketData, device: undefined });
            }}
            allowNewDevices={true}
            // This key hack allows to reset the element after bad input
            key={acKey2}
          />
          <Typography
            style={{ paddingTop: 10, paddingBottom: 10, fontWeight: "bold" }}
          >
            {t("ticketList.selectContact")}
          </Typography>
          <BrowseContactsDialog
            setClientInfoObject={(e, v) => {
              if (e.companyId) {
                setTicketData({
                  ...ticketData,
                  Company: e,
                  CompanyId: e.companyId,
                });
                return;
              }
              if (e.contactId) {
                setTicketData({
                  ...ticketData,
                  Contact: e,
                  ContactId: e.contactId,
                });
                return;
              }
            }}
            activeObject={clientObject}
          />
          {clientObject &&
          Object.keys(clientObject).length &&
          Object.values(clientObject) ? (
            <Grid container direction="row" style={{ marginTop: 5 }}>
              <Grid item xs={10}>
                <ContactInfoBadge
                  clientInfoObject={clientObject}
                  direction={"row"}
                  onClick={() => {
                    if (clientObject.companyId) {
                      history.push(
                        (checkAdmin() ? "/cpanel" : "") +
                          "/contacts/company/" +
                          clientObject.companyId,
                      );
                      return;
                    }
                    history.push(
                      (checkAdmin() ? "/cpanel" : "") +
                        "/contacts/contact/" +
                        clientObject.contactId,
                    );
                  }}
                />
              </Grid>
              <Grid item xs={2}>
                <IconButton
                  onClick={() => {
                    setTicketData({
                      ...ticketData,
                      Company: null,
                      CompanyId: null,
                    });
                  }}
                >
                  <Delete />
                </IconButton>
              </Grid>
            </Grid>
          ) : null}
          {ticketData?.newDevice ? (
            <Typography>
              {t("addingNewDevice")}: {ticketData.newDevice.toUpperCase()}
            </Typography>
          ) : null}{" "}
        </>
      ) : (
        <>
          <Typography>
            {selectedTicket?.Device?.serialNumber || Device.serialNumber}
          </Typography>
          {checkAdmin() ? (
            <Typography>{getWarrantyStatusText(deviceData, t)}</Typography>
          ) : null}
        </>
      )}
    </Grid>
  );
}

function ActionRow({ header, data }) {
  const checkData = (d) => {
    if (typeof d === "object") {
      return Object.keys(d).map((dd, idxx) => {
        var val = d[dd];
        if (Array.isArray(val)) {
          return val.map((ddd, idx) => {
            if (typeof ddd === "object") {
              return Object.keys(ddd).map((dddd, i) => {
                return (
                  <Typography key={idx + i}>
                    {dddd} : {ddd?.[dddd]}
                  </Typography>
                );
              });
            }
            return (
              <Typography key={idx}>
                {ddd} : {val[ddd]}
              </Typography>
            );
          });
        }
        return (
          <Typography key={idxx}>
            {dd} : {val}
          </Typography>
        );
      });
    }
    return <Typography style={{ whiteSpace: "pre-wrap" }}>{d}</Typography>;
  };
  return (
    <Grid item>
      <Typography style={{ fontWeight: "bold" }}>{header}</Typography>
      {checkData(data)}
    </Grid>
  );
}

function ActionsHistory({ ticket, spacing }) {
  const { t } = useTranslation();

  const sort = (a, b) => {
    return b.id - a.id;
  };

  const ignore = ["number", "id", "UserId", "DeviceId", "metadata"];
  const assignations = ["AssigneeId"];

  return (
    <Grid
      item
      container
      spacing={1}
      xs={12}
      style={{ height: window.innerHeight - 150, overflow: "scroll" }}
    >
      <Grid item xs={12}>
        <Title>{t("ticketList.changesHistory")}</Title>
      </Grid>
      {ticket &&
        ticket.TicketActions &&
        ticket.TicketActions.sort(sort).map((m, index) => (
          <Grid
            item
            container
            xs={12}
            key={index}
            style={{
              padding: 10,
              backgroundColor: index % 2 === 0 ? "rgba(245, 245, 245, 1)" : "",
            }}
          >
            <Grid item style={{ marginRight: 20 }} xs={2}>
              <Typography>{m.User?.fullName}</Typography>
              <Typography style={{ fontSize: 12 }}>
                {formatTimeWithTZOffset(m.updatedAt, ECABIN)}
              </Typography>
            </Grid>
            <Grid item xs={9}>
              <Typography>{t("ticketList.changes")}</Typography>
              <hr />
              {Object.keys(m.changes).map((g, i) => {
                if (ignore.find((f) => f === g)) {
                  return null;
                }
                if (assignations.find((f) => f === g)) {
                  return (
                    <ActionRow
                      key={i}
                      header={t("ticketList." + g)}
                      data={
                        m.changes[g] ? "New Person Assigned" : "Data Removed"
                      }
                    />
                  );
                }
                if (g === "priority") {
                  return (
                    <ActionRow
                      key={i}
                      header={t("ticketList." + g)}
                      data={Object.keys(TICKET_PRIORITIES).find(
                        (f) => TICKET_PRIORITIES[f] === m.changes[g],
                      )}
                    />
                  );
                }
                if (g === "clientContacted") {
                  return (
                    <ActionRow
                      key={i}
                      header={t("ticketList." + g)}
                      data={
                        contactMethods.find((f) => f.value === m.changes[g])
                          .label
                      }
                    />
                  );
                }
                if (g === "state") {
                  return (
                    <ActionRow
                      key={i}
                      header={t("ticketList." + g)}
                      data={t("ticketList." + m.changes[g])}
                    />
                  );
                }
                if (g === "expenses") {
                  return Object.keys(m.changes[g]).map((gg) => {
                    const expenses = m.changes[g];
                    return (
                      <ActionRow
                        key={i + gg}
                        header={t("ticketList." + gg)}
                        data={expenses[gg]
                          .map((e) => {
                            return `${e.count ? e.count + "x" : ""} ${
                              e.name
                            } - ${e.price}€`;
                          })
                          .join("\n")}
                      />
                    );
                  });
                }
                return (
                  <ActionRow
                    key={i}
                    header={t("ticketList." + g)}
                    data={m.changes[g] || "Data Removed"}
                  />
                );
              })}
            </Grid>
          </Grid>
        ))}
    </Grid>
  );
}

function ContactMethod({ data, dense, plain, iconSpace }) {
  const val = contactMethods.find((f) => f.value === data);
  if (plain) {
    return (
      <>
        {val?.icon || iconSpace ? (
          <ListItemIcon>
            {val?.icon && React.createElement(val.icon)}
          </ListItemIcon>
        ) : null}
        {val.label}
      </>
    );
  }

  return val ? (
    <ListItem dense={!!dense}>
      {val?.icon && (
        <ListItemIcon>{React.createElement(val.icon)}</ListItemIcon>
      )}
      {val.label}
    </ListItem>
  ) : null;
}

function TicketEntry({
  device_id,
  Device,
  selectedTicket,
  setSelectedTicket,
  showTicketEntry: show,
  setShowTicketEntry: hide,
  setRefreshList,
  showSearch,
  showHeader,
  width,
  ...rest
}) {
  const [ticketData, setTicketData] = useState();
  const [showUsers, setShowUsers] = useState(false);
  const [confirmDelete, setConfirmDelete] = useState();
  const classes = useStyles();
  const dispatch = useDispatch();
  const { t } = useTranslation();

  const submitTicket = () => {
    if (selectedTicket) {
      return;
    }
    if (!ticketData) {
      return;
    }
    const requestOptions = {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        token: getToken(),
        deviceid: device_id,
        // Initial state is new unless ticketData overrides it
        ticket_data: { state: "new", ...ticketData },
      }),
    };
    fetch(server + "/add_ticket", requestOptions)
      .then((res) => res.json())
      .then((result) => {
        requestErrorHandler(result, dispatch);

        if (!result.error) {
          dispatch(showPopupSnackbar(result));
          setTicketData();
          hide(false);
          if (setRefreshList) {
            setRefreshList(new Date().toISOString());
          }
        }
      });
  };

  const checkChanges = () => {
    return !ticketData;
  };

  const handleClose = () => {
    setSelectedTicket();
    setTicketData();
    setConfirmDelete();
    setShowUsers(false);
    hide(false);
  };

  const editTicket = (deleteTicket) => {
    if (!selectedTicket) {
      return;
    }
    const requestOptions = {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        token: getToken(),
        deviceid: device_id ?? selectedTicket.DeviceId,
        ticket_data: { ...selectedTicket, ...ticketData },
        deleteTicket: deleteTicket ?? undefined,
      }),
    };
    fetch(server + "/edit_ticket", requestOptions)
      .then((res) => res.json())
      .then((result) => {
        requestErrorHandler(result, dispatch);

        if (!result.error) {
          dispatch(showPopupSnackbar(result));
          setTicketData();
          hide(false);
          if (setRefreshList) {
            setRefreshList(new Date().toISOString());
          }
        }
      });
  };
  return show ? (
    <Dialog open={!!show} fullScreen onClose={handleClose}>
      <DialogContent>
        <DialogAppBar
          onClose={handleClose}
          header={
            !selectedTicket && showSearch ? (
              t("newTicket")
            ) : selectedTicket?.Device && showHeader ? (
              <>
                {" "}
                {selectedTicket?.Device.serialNumber} -{" "}
                <Link
                  href={"/cpanel/devices/" + selectedTicket?.Device.id}
                  style={{ color: "white" }}
                >
                  {t("viewDevicePage")}
                </Link>
              </>
            ) : null
          }
        />
        <Grid
          container
          style={{ marginTop: 60 }}
          spacing={width === "xs" ? 0 : 1}
        >
          <Grid item xs={width !== "xs" ? 8 : 12}>
            <Grid
              container
              item
              xs={12}
              spacing={3}
              justify="space-around"
              style={{
                borderRight: "1px solid #000",
                height: window.innerHeight - 150,
                overflow: "scroll",
              }}
            >
              <IdentificationSegment
                selectedTicket={selectedTicket}
                Device={Device}
                showSearch={showSearch}
                ticketData={ticketData}
                setTicketData={setTicketData}
              />
              <Grid item sm={3} xs={12}>
                <Title>{t("ticketList.priority")}</Title>
                <TextField
                  select
                  fullWidth
                  onChange={(e) => {
                    setTicketData({ ...ticketData, priority: e.target.value });
                  }}
                  variant="outlined"
                  defaultValue={selectedTicket?.priority || ""}
                  label={t("ticketList.priority")}
                >
                  {Object.keys(TICKET_PRIORITIES).map((m) => (
                    <MenuItem key={m} value={TICKET_PRIORITIES[m]}>
                      {m}
                    </MenuItem>
                  ))}
                </TextField>
              </Grid>

              <Grid item sm={3} xs={12}>
                <Title>{t("ticketList.AssigneeId")}</Title>
                {selectedTicket && selectedTicket.Assignee && !showUsers ? (
                  <Paper className={classes.paper}>
                    <Grid container justify="space-between" alignItems="center">
                      <Grid item>
                        <AccountCircle />
                      </Grid>
                      <Grid item>
                        <Typography>
                          {selectedTicket.Assignee.emailAddress}
                        </Typography>
                      </Grid>
                      <Grid item>
                        <IconButton
                          onClick={() => {
                            setShowUsers((e) => !e);
                            setTicketData({ ...ticketData, AssigneeId: null });
                          }}
                        >
                          <Clear />
                        </IconButton>
                      </Grid>
                    </Grid>
                  </Paper>
                ) : (
                  <UserSearchAutocomplete
                    required={true}
                    onChange={(e, v) => {
                      if (v) {
                        setTicketData({ ...ticketData, AssigneeId: v.id });
                        return;
                      }
                      setTicketData({ ...ticketData, AssigneeId: undefined });
                    }}
                    userGroup={"CTN"}
                    additionalDataFields={["emailAddress"]}
                  ></UserSearchAutocomplete>
                )}
              </Grid>
              <Grid item sm={3} xs={12}>
                <Title> {t("ticketList.state")}</Title>
                <TextField
                  variant="outlined"
                  select
                  fullWidth
                  defaultValue={selectedTicket?.state ?? "new"}
                  label={t("ticketList.state")}
                  onChange={(e, v) => {
                    setTicketData({ ...ticketData, state: e.target.value });
                  }}
                >
                  {ticketStates.map((option) => (
                    <MenuItem key={option.value} value={option.value}>
                      {t("ticketList." + option.value)}
                    </MenuItem>
                  ))}
                </TextField>
              </Grid>
              <Grid xs={12} item>
                {selectedTicket?.summary ? (
                  <>
                    {" "}
                    <hr />
                    <Title>{t("ticketList.summary")}</Title>
                    <Typography style={{ whiteSpace: "pre-wrap" }}>
                      {selectedTicket.summary}
                    </Typography>
                  </>
                ) : null}

                <hr />
                <Title>{t("ticketList.backgroundInfo")}</Title>
              </Grid>
              <Grid item xs={12}>
                <Typography
                  style={{
                    paddingTop: 10,
                    paddingBottom: 10,
                    fontWeight: "bold",
                  }}
                >
                  {t("ticketList.description")}
                </Typography>
                {selectedTicket?.description ? (
                  <Typography style={{ whiteSpace: "pre-wrap" }}>
                    {selectedTicket?.description}
                  </Typography>
                ) : (
                  <TextField
                    variant="outlined"
                    fullWidth
                    multiline
                    defaultValue={selectedTicket?.description}
                    rows={4}
                    placeholder={t("ticketList.descriptionPlaceholder")}
                    label={t("ticketList.description")}
                    onChange={(e) => {
                      if (e.target.value) {
                        setTicketData({
                          ...ticketData,
                          description: e.target.value,
                        });
                        return;
                      }
                      setTicketData({ ...ticketData, description: null });
                    }}
                  ></TextField>
                )}
              </Grid>
              <Grid item xs={12}>
                <Typography
                  style={{
                    paddingTop: 10,
                    paddingBottom: 10,
                    fontWeight: "bold",
                  }}
                >
                  {t("ticketList.details")}
                </Typography>
                {selectedTicket?.details ? (
                  <Typography style={{ whiteSpace: "pre-wrap" }}>
                    {selectedTicket.details}
                  </Typography>
                ) : (
                  <TextField
                    variant="outlined"
                    fullWidth
                    multiline
                    placeholder={t("ticketList.detailsPlaceholder")}
                    defaultValue={selectedTicket?.details}
                    rows={4}
                    label={t("ticketList.details")}
                    onChange={(e) => {
                      if (e.target.value) {
                        setTicketData({
                          ...ticketData,
                          details: e.target.value,
                        });
                        return;
                      }
                      setTicketData({ ...ticketData, details: null });
                    }}
                  ></TextField>
                )}
              </Grid>
              <Grid item xs={12}>
                <hr />
                <Title>{t("ticketList.actionsTaken")}</Title>
              </Grid>
              <Grid item xs={12}>
                <Typography
                  style={{
                    paddingTop: 10,
                    paddingBottom: 10,
                    fontWeight: "bold",
                  }}
                >
                  {t("ticketList.clientContacted")}
                </Typography>
                {/* {selectedTicket?.clientContacted ? (
                  <ContactMethod data={selectedTicket.clientContacted} />
                ) : ( */}
                <TextField
                  fullWidth
                  select
                  label={t("ticketList.clientContacted")}
                  variant="outlined"
                  onChange={(e) => {
                    setTicketData({
                      ...ticketData,
                      clientContacted: e.target.value,
                    });
                  }}
                >
                  {contactMethods.map((m) => (
                    <MenuItem value={m.value} label={m.label} key={m.value}>
                      <ContactMethod
                        data={m.value}
                        plain={true}
                        iconSpace={true}
                      />
                    </MenuItem>
                  ))}
                </TextField>
                {/* )} */}
              </Grid>
              <Grid item xs={12}>
                <Typography
                  style={{
                    paddingTop: 10,
                    paddingBottom: 10,
                    fontWeight: "bold",
                  }}
                >
                  {t("ticketList.actionDescription")}
                </Typography>
                <TextField
                  variant="outlined"
                  fullWidth
                  multiline
                  // Show default value if History is not available
                  defaultValue={
                    selectedTicket?.TicketActions &&
                    selectedTicket?.TicketActions.length
                      ? null
                      : selectedTicket?.action
                  }
                  rows={4}
                  placeholder={t("ticketList.actionPlaceholder")}
                  label={t("ticketList.action")}
                  onChange={(e) => {
                    if (e.target.value) {
                      setTicketData({ ...ticketData, action: e.target.value });
                      return;
                    }
                    setTicketData({ ...ticketData, action: null });
                  }}
                ></TextField>
              </Grid>

              <Grid item xs={12}>
                <DetailTabs
                  activeTabs={[
                    width === "xs"
                      ? {
                          permission: [
                            USER_GROUPS.ADMIN,
                            USER_GROUPS.SUPER_USER,
                          ],
                          label: t("ticketList.changesHistory"),
                          content: <ActionsHistory ticket={selectedTicket} />,
                        }
                      : null,
                    {
                      permission: [USER_GROUPS.ADMIN, USER_GROUPS.SUPER_USER],
                      label: t("media"),
                      content: <MediaFiles ticket={selectedTicket} />,
                    },
                    {
                      permission: [USER_GROUPS.ADMIN, USER_GROUPS.SUPER_USER],
                      label: t("ticketList.expenses"),
                      content: (
                        <Expenses
                          ticketData={ticketData}
                          setTicketData={setTicketData}
                          selectedTicket={selectedTicket}
                        />
                      ),
                    },
                    // {
                    //   permission: [USER_GROUPS.SUPER_USER],
                    //   label: "WhatsApp",
                    //   content: <WhatsAppView selectedTicket={selectedTicket} />,
                    //   disabled: true,
                    // },
                  ]}
                />
              </Grid>
              <Grid item xs={12} style={{ height: 100 }}>
                {/* Spacing for floating buttons */}
              </Grid>
              <div
                style={{
                  position: "absolute",
                  bottom: 2,
                  left: 0,
                  width: "100%",
                  padding: 10,
                  backgroundColor: "white",
                  boxShadow: "#d6d6d6 0px 0px 15px 0px",
                  zIndex: 90,
                }}
              >
                <Grid container item xs={6} spacing={3}>
                  <Grid item>
                    <Button
                      disabled={checkChanges()}
                      variant="contained"
                      color="primary"
                      onClick={() => {
                        if (selectedTicket) {
                          editTicket();
                          return;
                        }
                        submitTicket();
                      }}
                    >
                      {t("submit")}
                    </Button>
                  </Grid>
                  <Grid item>
                    <Button variant="outlined" onClick={handleClose}>
                      {t("cancel")}
                    </Button>
                  </Grid>
                  {selectedTicket && !confirmDelete ? (
                    <Grid item>
                      <Button
                        variant="contained"
                        color="secondary"
                        onClick={() => {
                          setConfirmDelete(true);
                        }}
                      >
                        {t("delete")}
                      </Button>
                    </Grid>
                  ) : null}
                  {confirmDelete ? (
                    <Grid item>
                      <Typography>{t("areYouSure")}?</Typography>
                      <Button
                        variant="contained"
                        color="secondary"
                        onClick={() => {
                          editTicket(true);
                          setConfirmDelete(false);
                        }}
                      >
                        {t("confirmDelete")}
                      </Button>
                      <Button
                        variant="outlined"
                        onClick={() => {
                          setConfirmDelete(false);
                        }}
                      >
                        {t("cancel")}
                      </Button>
                    </Grid>
                  ) : null}
                </Grid>
              </div>
            </Grid>
          </Grid>
          {width !== "xs" ? (
            <Grid item xs={4}>
              <ActionsHistory ticket={selectedTicket} />
            </Grid>
          ) : null}
        </Grid>
      </DialogContent>
    </Dialog>
  ) : null;
}

export default withWidth()(TicketEntry);
